const OAUTH_CLIENT_SECRET_LENGTH = 30;
const UPPERCASE_LETTERS = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ';
const DIGITS = '0123456789';
const OAUTH_CLIENT_SECRET_CHARSET = `${UPPERCASE_LETTERS}${UPPERCASE_LETTERS.toLowerCase()}${DIGITS}`;

/**
 * Generates a client secret matching the backend contract `^[a-zA-Z0-9]{30,}$`.
 * The secret is generated on the FE and sent in the request (T20-124309).
 *
 * FE generation is a UX convenience, not the security boundary: the backend is
 * the authority on secret validation and must enforce its own strength/entropy
 * policy on the incoming `clientSecret` field.
 */
export function generateOAuthClientSecret() {
  const randomValues = new Uint32Array(OAUTH_CLIENT_SECRET_LENGTH);
  crypto.getRandomValues(randomValues);

  return Array.from(
    randomValues,
    (value) => OAUTH_CLIENT_SECRET_CHARSET[value % OAUTH_CLIENT_SECRET_CHARSET.length]
  ).join('');
}
